module.exports = {
    messages: {
        de: {
            transcript: {
                bundle: "Konvolut",
                citation: "Zitier-Empfehlung",
                crossFade: "Überblendung Faksimile / Transkription",
                downloadTei: "TEI-Datei herunterladen",
                fullScreenMode: "Vollansicht",
                markPersons: "Personenmarkierung",
                markProjects: "Stückemarkierung",
                metadata: "Metadaten",
                reset: "Ansicht zurücksetzen",
                scaleDown: "Ansicht verkleinern",
                scaleUp: "Ansicht vergrößern",
                toc: "Inhalt",
                turnLeft: "Nach links drehen",
                turnRight: "Nach rechts drehen",
                watchlist: "Merkliste"
            }
        },
        en: {
            transcript: {
                bundle: "Set",
                citation: "recommended citation",
                crossFade: "Cross-fade facsimile / transcription",
                downloadTei: "Download TEI file",
                fullScreenMode: "Full screen mode",
                markPersons: "Mark persons",
                markProjects: "Mark projects",
                metadata: "Metadata",
                reset: "Reset view",
                scaleDown: "Scale down",
                scaleUp: "Scale up",
                toc: "Table of contents",
                turnLeft: "Rotate left",
                turnRight: "Rotate right",
                watchlist: "Watch list"
            }
        },
        fr: {
            transcript: {
                bundle: "Liasse",//"Konvolut",
                citation: "Référence",//"citation",
                crossFade: "Transition fac-similé / transcription",
                downloadTei: "Fichier TEI",//"Télécharger le fichier TEI",
                fullScreenMode: "Plein écran",
                markPersons: "Marquage de personnes",
                markProjects: "Marquage des titres",
                metadata: "Métadonnées",
                reset: "Réinitialiser l’aperçu",//"Réinitialiser la vue",
                scaleDown: "Zoom arrière",//"Rétrécir",
                scaleUp: "Zoom avant",//"Grandir",
                toc: "Table de matières",
                turnLeft: "Rotation antihoraire",//"Tourner à gauche",
                turnRight: "Rotation horaire",//"Tourner à droite",
                watchlist: "Liste des favoris"
            }
        }
    }
}
